import { alertConstants } from '../_constants';

export function alert(state = { clear: true, autohide: true }, action) {
  switch (action.type) {
    case alertConstants.SUCCESS:
      return {
        type: 'alert-success',
        message: action.message,
        clear: false,
        autohide: true,
      };
    case alertConstants.ERROR:
      return {
        type: 'alert-danger',
        message: action.message,
        clear: false,
        autohide: true,
      };
    case alertConstants.NOTIFICATION:
      return {
        type: 'alert-warning',
        message: action.message,
        clear: false,
        autohide: action.autohide,
      };
    case alertConstants.SYNC:
      return {
        type: 'alert-light',
        message: action.message,
        clear: false,
        autohide: true,
      };
    case alertConstants.OFFLINE:
      return {
        type: 'alert-offline',
        message: action.message,
        clear: false,
        autohide: false,
      };
    case alertConstants.CLEAR:
      return { clear: true, autohide: true };
    default:
      return state;
  }
}
